import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {DateRangeTemplateType} from "../../../commons/types/date-range-template.type";
import {ViewSettingsModel} from "../../../commons/models/view-settings.model";
import {SiteFiltersType} from "../../../commons/types/site-filters.type";
import {ViewFilterSettingsService} from "../../../commons/services/view-filter-settings.service";
import {SurveyRequests} from "../../services/survey-requests.service";
import {SurveyService} from "../../services/survey-service.service";
import {DateRangeTimeFiltersService} from "../../../commons/services/date-range-time-filters.service";
import {SplitService} from "../../../commons/services/split-service.service";
import {AccountType} from "../../../account/types/account.type";
import {SurveyAlerts} from "../../services/survey-alerts.service";
import {ExportSurveyRequestModel} from "../../models/export-survey-request.model";
import {ExportType} from "../../../commons/types/export.type";
import {EXPORT_CSV_SIZE_LIMIT, EXPORT_EXCEL_SIZE_LIMIT} from "../../../commons/angular/constants/commons";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";

declare let google: any;

export class surveyDetailsCtrl implements IController {

  dateRangeTemplateType?: DateRangeTemplateType;
  from: any;
  to: any;
  type: any;
  branchIds: string[];
  accountIds: string[];
  agentIds: string[];
  supplyAccountIds: string[];
  selectedQuickFilterId?: string;
  surveyScore: string;

  public pageName: string;
  public filterConfig: any;
  public totals: any;
  public starsAvg: any;
  public fiveStarPercent: any;
  public starsTotal: any;
  public charts: any;
  public infiniteScroll: any;

  private loadLimit: number;
  private siteId: any;
  private reviewsRef: any;
  public accountType: typeof AccountType = AccountType;


  /* @ngInject */
  constructor(private dateRangeTimeFiltersService: DateRangeTimeFiltersService, private surveyRequests: SurveyRequests,
              private surveyService: SurveyService, private $survey, private $log, private $state, private $filter, private $translate,
              private confirmDialogService: ConfirmDialogService, private splitService: SplitService,
              private $infiniteScroll, private viewFilterSettingsService: ViewFilterSettingsService, private surveyAlerts: SurveyAlerts) {
    this.pageName = $state.current.name;
  }

  $onInit() {
    this.loadLimit = 30;
    this.siteId = this.splitService.getSiteId();
    this.reviewsRef = this.$survey();

    this.filterConfig = {
      siteId: this.siteId,
      customTemplates: this.dateRangeTimeFiltersService.getDeliveriesCustomTemplates(),
      range: this.dateRangeTemplateType ? this.dateRangeTimeFiltersService.getDateRangeFilterByType(this.dateRangeTemplateType) :
        ((this.from && this.to) ? {dateStart: this.from, dateEnd: this.to} : this.dateRangeTimeFiltersService.thisMonth()),
      includeFilters: [SiteFiltersType.dateRangeTemplateType, SiteFiltersType.branchIds, SiteFiltersType.accountIds, SiteFiltersType.supplyAccountIds, SiteFiltersType.agentIds, SiteFiltersType.surveyScore],
      bringozFilters: {
        [SiteFiltersType.dateRangeTemplateType]: this.dateRangeTemplateType,
        [SiteFiltersType.branchIds]: this.branchIds || [],
        [SiteFiltersType.accountIds]: this.accountIds || [],
        [SiteFiltersType.supplyAccountIds]: this.supplyAccountIds || [],
        [SiteFiltersType.agentIds]: this.agentIds || [],
        [SiteFiltersType.surveyScore]: this.surveyScore
      },
      queryMap: {
        supplierType: this.accountType.BusinessSupply
      }
    };

    this.starsAvg = undefined;
    this.fiveStarPercent = undefined;

    this.charts = [];
    this.infiniteScroll = undefined;

    if (!this.type) {
      this.type = {
        questions: []
      };
    }
    this.reInitData();

    // Survey Create/Change/Remove Event Listener
    this.reviewsRef.$subscribeToChannelEvents((surveys, action) => {
      if (action === 'created') {
        this.infiniteScroll.addItems(surveys);
        this.surveyAlerts.createSuccess();

        this._getTotals();
      }
    })

  }

  $onDestroy() {
    this.reviewsRef.$destroyChannel();
  }

  onRangeChanged(range) {
    this.filterConfig.range = range;

    if (this.selectedQuickFilterId && range?.type !== this.filterConfig.bringozFilters.dateRangeTemplateType) {
      this.selectedQuickFilterId = undefined;
    }

    this.filterConfig.bringozFilters.dateRangeTemplateType = this.dateRangeTimeFiltersService.getDateRangeFilterByType(range.type)?.type;

    this._setStateParams();
    this.reInitData();
  }

  onQuickFilterSelect(quickFilter: ViewSettingsModel) {
    if (!!quickFilter) {
      this.onFiltersChange(quickFilter.settings, quickFilter);
    } else {
      const filters = angular.copy(this.filterConfig.bringozFilters);
      _.forOwn(filters, (value, key) => {
        filters[key] = _.isArray(value) ? [] : undefined;
      })
      this.onFiltersChange(filters);
    }
  }

  onFiltersChange(filters, selectedQuickFilter?) {
    this.filterConfig.bringozFilters = filters;
    this.viewFilterSettingsService.setActiveQuickFilter(selectedQuickFilter, this.pageName);
    this.selectedQuickFilterId = selectedQuickFilter?.id;

    if (!!filters.dateRangeTemplateType) {
      this.filterConfig.range = this.dateRangeTimeFiltersService.getDateRangeFilterByType(filters.dateRangeTemplateType);
    }

    this._setStateParams();
    this.reInitData();
  }

  onExport(event, exportType: ExportType) {
    let limit = this.starsTotal.numberOfAnswers || 0;
    let extraText;
    const text = 'Are you sure you want to export?';
    if (exportType === ExportType.Excel) {
      if (limit > EXPORT_EXCEL_SIZE_LIMIT) {
        extraText = 'EXPORT_INFO_LIMIT';
      }
      this.confirmDialogService.confirmWithInfo('Export', text, extraText, {x: EXPORT_EXCEL_SIZE_LIMIT}, event)
        .then(() => {
          this._export(exportType);
        })
        .catch((error) => {
          this.$log.info('Dialog Closed');
        });
    } else if (ExportType.CSV) {
      if (limit > EXPORT_CSV_SIZE_LIMIT) {
        extraText = 'EXPORT_INFO_LIMIT';
      }
      this.confirmDialogService.confirmWithInfo('Export', text, extraText, {x: EXPORT_CSV_SIZE_LIMIT}, event)
        .then(() => {
          this._export(exportType);
        })
        .catch((error) => {
          this.$log.info('Dialog Closed');
        });
    }

  }

  private _export(exportType: ExportType) {
    const exportSurveyRequest: ExportSurveyRequestModel = {
      fieldTranslationMap: this._getExportTablePayload(),
      accountIds:this.filterConfig.bringozFilters.accountIds,
      agentAccountIds: this.filterConfig.bringozFilters.supply,
      agentIds: this.filterConfig.bringozFilters.agentIds,
      survey: this.type?.survey || 'GENERAL',
      from: this.filterConfig.range.dateStart,
      to: this.filterConfig.range.dateEnd,
      zoneId: this.splitService.getTimeZone(),
      score: this.filterConfig.bringozFilters.surveyScore,
      exportType: exportType
    }

    this.surveyService.exportData(exportSurveyRequest,this.filterConfig.bringozFilters.branchIds)
      .then((res) => {

      })
  }

  private _getExportTablePayload(): any {
    return {
      date: this.$translate.instant('EXPORT_SURVEY_TABLE_COLUMNS.date'),
      serviceId: this.$translate.instant('EXPORT_SURVEY_TABLE_COLUMNS.serviceId'),
      customersName: this.$translate.instant('EXPORT_SURVEY_TABLE_COLUMNS.customersName'),
      customersAddress: this.$translate.instant('EXPORT_SURVEY_TABLE_COLUMNS.customersAddress'),
      customersCity: this.$translate.instant('EXPORT_SURVEY_TABLE_COLUMNS.customersCity'),
      customersStreet: this.$translate.instant('EXPORT_SURVEY_TABLE_COLUMNS.customersStreet'),
      customersPhone: this.$translate.instant('EXPORT_SURVEY_TABLE_COLUMNS.customersPhone'),
      agentsName: this.$translate.instant('EXPORT_SURVEY_TABLE_COLUMNS.agentsName'),
      accuracy: this.$translate.instant('EXPORT_SURVEY_TABLE_COLUMNS.accuracy'),
      productsQuality: this.$translate.instant('EXPORT_SURVEY_TABLE_COLUMNS.productsQuality'),
      cooledProductsQuality: this.$translate.instant('EXPORT_SURVEY_TABLE_COLUMNS.cooledProductsQuality'),
      courtesy: this.$translate.instant('EXPORT_SURVEY_TABLE_COLUMNS.courtesy'),
      serviceQuality: this.$translate.instant('EXPORT_SURVEY_TABLE_COLUMNS.serviceQuality'),
      reviewContent: this.$translate.instant('EXPORT_SURVEY_TABLE_COLUMNS.reviewContent'),
      recommend: this.$translate.instant('EXPORT_SURVEY_TABLE_COLUMNS.recommend'),
      satisfied: this.$translate.instant('EXPORT_SURVEY_TABLE_COLUMNS.satisfied'),
      score: this.$translate.instant('EXPORT_SURVEY_TABLE_COLUMNS.score'),
      accountId: this.$translate.instant('EXPORT_SURVEY_TABLE_COLUMNS.accountId'),
      accountName: this.$translate.instant('EXPORT_SURVEY_TABLE_COLUMNS.accountName'),
      serviceExternalId: this.$translate.instant('EXPORT_SURVEY_TABLE_COLUMNS.serviceExternalId'),
      dropoffNotBefore: this.$translate.instant('EXPORT_SURVEY_TABLE_COLUMNS.dropoffNotBefore'),
      dropoffNotAfter: this.$translate.instant('EXPORT_SURVEY_TABLE_COLUMNS.dropoffNotAfter'),
      lastAction: this.$translate.instant('EXPORT_SURVEY_TABLE_COLUMNS.lastAction'),
      punctuality: this.$translate.instant('EXPORT_SURVEY_TABLE_COLUMNS.punctuality'),
      informationProvided: this.$translate.instant('EXPORT_SURVEY_TABLE_COLUMNS.informationProvided'),
      noneIssue: this.$translate.instant('EXPORT_SURVEY_TABLE_COLUMNS.noneIssue'),
      noneTimeLines: this.$translate.instant('EXPORT_SURVEY_TABLE_COLUMNS.noneTimeLines'),
      timeLines: this.$translate.instant('EXPORT_SURVEY_TABLE_COLUMNS.timeLines'),
      appointmentCoordination: this.$translate.instant('EXPORT_SURVEY_TABLE_COLUMNS.appointmentCoordination'),
      noneAppointmentCoordination: this.$translate.instant('EXPORT_SURVEY_TABLE_COLUMNS.noneAppointmentCoordination'),
      cleanliness: this.$translate.instant('EXPORT_SURVEY_TABLE_COLUMNS.cleanliness'),
      quickness: this.$translate.instant('EXPORT_SURVEY_TABLE_COLUMNS.quickness'),
      noneInformationProvided: this.$translate.instant('EXPORT_SURVEY_TABLE_COLUMNS.noneInformationProvided'),
      noneServiceQuality: this.$translate.instant('EXPORT_SURVEY_TABLE_COLUMNS.noneServiceQuality'),
      noneProductsQuality: this.$translate.instant('EXPORT_SURVEY_TABLE_COLUMNS.noneProductsQuality')

    }
  }

  private _setStateParams() {
    this.$state.go('.', this._getQueryParams(), {notify: false, reload: false});
  }

  private reInitData() {
    this.charts = [];
    this.getReviews();
    this._getTotals();
  }

  private _getTotals() {
    this.getTotals(
      this.filterConfig.range.dateStart,
      this.filterConfig.range.dateEnd,
      this.type.survey,
      this.filterConfig.bringozFilters.branchIds,
      this.filterConfig.bringozFilters.accountIds,
      this.filterConfig.bringozFilters.supplyAccountIds,
      this.filterConfig.bringozFilters.agentIds,
      this.filterConfig.bringozFilters.surveyScore);
  }

  private getReviews() {
    if (this.infiniteScroll) {
      this.queryReviews();
    } else {
      this.reviewsRef.$query(this.getQueryPayload());
      this.infiniteScroll = this.$infiniteScroll(this.reviewsRef, this.loadLimit, {getFullData: true});
    }
  }

  private getQueryPayload() {
    return {
      limit: this.loadLimit,
      from: this.filterConfig.range.dateStart,
      to: this.filterConfig.range.dateEnd,
      type: this.type.survey,
      branchIds: this.filterConfig.bringozFilters.branchIds,
      accountIds: this.filterConfig.bringozFilters.accountIds,
      agentAccountIds: this.filterConfig.bringozFilters.supplyAccountIds,
      agentIds: this.filterConfig.bringozFilters.agentIds,
      score: this.filterConfig.bringozFilters.surveyScore,
      expand: true
    };
  }

  private _getQueryParams() {
    return {
      dateRangeTemplateType: this.filterConfig.bringozFilters.dateRangeTemplateType,
      from: this.filterConfig.range.dateStart,
      to: this.filterConfig.range.dateEnd,
      branchIds: this.filterConfig.bringozFilters.branchIds,
      accountIds: this.filterConfig.bringozFilters.accountIds,
      supplyAccountIds: this.filterConfig.bringozFilters.supplyAccountIds,
      agentIds: this.filterConfig.bringozFilters.agentIds,
      score: this.filterConfig.bringozFilters.surveyScore,
    }
  }

  private queryReviews() {
    this.reviewsRef.$query(this.getQueryPayload())
      .then(() => {
        this.infiniteScroll.reload();
      })
      .catch((error) => {
        if (error) {
          this.$log.error('Fail to $query', error);
        }
      })
  }

  private getTotals(from, to, type, branchIds, accountIds, agentAccountIds, agentIds, surveyScore?: string) {

    this.surveyRequests.getTotals(from, to, type, branchIds, accountIds, agentAccountIds, agentIds, surveyScore)
      .then((totals) => {
        this.totals = totals;

        const starsTotal = _.find(totals, (t) => {
          return t.type === 'STARS';
        })

        if (!!starsTotal) {
          this.starsTotal = starsTotal;
          this.fiveStarPercent = ((starsTotal.numberOf5Star / starsTotal.numberOfAnswers) * 100).toFixed(1);
          // numberOfAnswers includes answers without a score, so average only over actual star ratings
          const numberOfScoredAnswers = starsTotal.numberOf1Star + starsTotal.numberOf2Star + starsTotal.numberOf3Star +
            starsTotal.numberOf4Star + starsTotal.numberOf5Star;
          this.starsAvg = ((
            (starsTotal.numberOf1Star) +
            (starsTotal.numberOf2Star * 2) +
            (starsTotal.numberOf3Star * 3) +
            (starsTotal.numberOf4Star * 4) +
            (starsTotal.numberOf5Star * 5)
          ) / numberOfScoredAnswers).toFixed(1);
        }

        this.initCharts(totals);
      })
  }

  private getCharts(totals) {
    const charts = [];
    let starsChart;
    _.forEach(totals, (t) => {
      const isStarType = t.type === 'STARS';
      const chart = {
        name: t.question,
        chart: isStarType ? this.getStarsChartConfig() : this.getBooleanChartConfig()
      };

      if (isStarType) {
        starsChart = chart;
      } else {
        charts.push(chart);
      }
    });

    if (starsChart) {
      charts.unshift(starsChart);
    }

    return charts;
  }

  private initCharts(totals) {
    this.charts = this.getCharts(totals);

    _.forEach(totals, (t, index) => {
      const isStar = t.type === 'STARS';
      const chartIndex = _.findIndex(this.charts, (c: any) => {
        return c.name === t.question;
      });

      const groupedData = isStar ? this.groupStarRating(t) : this.groupBoolean(t);

      if (groupedData) {
        this.charts[chartIndex].chart.data = groupedData;
      }
    });
  }

  private getStarsChartConfig() {
    return {
      type: 'ColumnChart',
      data: {},
      options: {
        bars: 'vertical',
        hAxis: {
          viewWindow: {
            min: 0,
            max: 6
          },
          ticks: [1, 2, 3, 4, 5],
          gridlines: {
            color: 'transparent'
          }
        },
        vAxis: {
          minValue: 0,
          maxValue: 100,
          format: '#\'%\'',
          textPosition: 'none',
          gridlines: {
            color: 'transparent'
          }
        },
        chartArea: {
          width: "100%"
        },
        bar: {
          groupWidth: '40%'
        },
        legend: 'none',
        interpolateNulls: true,
        colors: ['#c5c5c5'],
        animation: {
          startup: true,
          duration: 2000,
          easing: "inAndOut"
        }
      }
    }
  }

  private getBooleanChartConfig() {
    return {
      type: 'ColumnChart',
      data: {},
      options: {
        bars: 'vertical',
        vAxis: {
          minValue: 0,
          maxValue: 100,
          format: '#\'%\'',
          textPosition: 'none',
          gridlines: {
            color: 'transparent'
          }
        },
        legend: 'none',
        colors: ['#c5c5c5'],
        sortAscending: true,
        chartArea: {
          width: "100%"
        },
        animation: {
          startup: true,
          duration: 1000,
          easing: "inAndOut"
        }
      }
    }
  }

  private groupStarRating(total) {
    return new google.visualization.arrayToDataTable([
      ['Answer', '%'],
      ["1", (total.numberOf1Star / total.numberOfAnswers) * 100],
      ["2", (total.numberOf2Star / total.numberOfAnswers) * 100],
      ["3", (total.numberOf3Star / total.numberOfAnswers) * 100],
      ["4", (total.numberOf4Star / total.numberOfAnswers) * 100],
      ["5", (total.numberOf5Star / total.numberOfAnswers) * 100]
    ]);
  }

  private groupBoolean(total) {
    return new google.visualization.arrayToDataTable([
      ['Answer', '%', {type: "string", role: "style"}],
      [this.$filter('translate')("Yes"), (total.numberOfTrue / total.numberOfAnswers) * 100, '#81D081'],
      [this.$filter('translate')("No"), (total.numberOfFalse / total.numberOfAnswers) * 100, '#FF6B6D']
    ]);
  }

}

angular
  .module('bringoz.admin.survey')
  .component('surveyDetails', {
    bindings: {
      dateRangeTemplateType: '<?',
      from: '<',
      to: '<',
      type: '<',
      branchIds: '<?',
      accountIds: '<?',
      agentIds: '<?',
      supplyAccountIds: '<?',
      surveyScore: '<?',
      selectedQuickFilterId: '<?'
    },
    template: require('./survey-details.html').default,
    controller: surveyDetailsCtrl
  });
